import {DescriptorEnum} from "../../config/descriptors/descriptor.enum";

export class DescriptorLink {

  id: string;
  type: DescriptorEnum;
  value: string;

  constructor(attr: {id: string, type: DescriptorEnum, value?: string}) {
    this.id = attr.id;
    this.type = attr.type;
    this.value = attr.value;
  }
}
